import { Box, styled } from '@mui/material';

const PREFIX = 'TSMED-HubStatusCard';
export const classes = {
  iconRowEast: `${PREFIX}-iconRowEast`,
  iconRowWest: `${PREFIX}-iconRowWest`,
  iconRow: `${PREFIX}-iconRow`,
  countRows: `${PREFIX}-countRows`,
  countRowsAlignStart: `${PREFIX}-countRowsAlignStart`,
  countRowsAlignEnd: `${PREFIX}-countRowsAlignEnd`,
  countsRowEast: `${PREFIX}-countsRowEast`,
  countsRowWest: `${PREFIX}-countsRowWest`,
  verticalColumn: `${PREFIX}-verticalColumn`,
  staffIcon: `${PREFIX}-staffIcon`,
  counts: `${PREFIX}-counts`,
  circle: `${PREFIX}-circle`,
  square: `${PREFIX}-square`,
  rhombus: `${PREFIX}-rhombus`,
  abbreviation: `${PREFIX}-abbreviation`,
  row: `${PREFIX}-row`,
  resourcesBox: `${PREFIX}-deviceSpecialistBox`,
};

type RootProps = {
  isEast: boolean;
  isFlat?: boolean;
};

export const BaseCard = styled(Box, {
  shouldForwardProp: prop => prop !== 'isEast' && prop !== 'isFlat',
})<RootProps>(({ isEast, isFlat, theme: { utils } }) => ({
  display: isEast ? 'block' : 'flex',
  alignItems: isEast ? 'flex-start' : 'flex-end',
  transition: 'opacity 0.2s ease',
  cursor: 'pointer',

  '&:hover': {
    opacity: 0.7,
  },

  [`.${classes.verticalColumn}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: isFlat ? 'center' : isEast ? 'flex-end' : 'flex-start',
    height: '100%',
    justifyContent: 'space-between',
  },
  [`.${classes.resourcesBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: isEast ? 'flex-end' : 'flex-start',
    height: '100%',
    justifyContent: 'center',
  },
  [`.${classes.iconRow}`]: {
    display: 'flex',
    gap: utils.clamp(3, 5),
  },
  [`.${classes.iconRowEast}`]: {
    flexDirection: 'row',
  },
  [`.${classes.iconRowWest}`]: {
    flexDirection: 'row-reverse',
  },
  [`.${classes.countsRowEast}`]: {
    flexDirection: 'row',
  },
  [`.${classes.countsRowWest}`]: {
    flexDirection: 'row-reverse',
  },
  [`.${classes.staffIcon}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '-5px',
  },
  [`.${classes.counts}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
  },
  [`.${classes.circle}`]: {
    width: utils.clamp(4, 6),
    height: utils.clamp(4, 6),
    borderRadius: '50%',
  },
  [`.${classes.square}`]: {
    width: utils.clamp(4, 5),
    height: utils.clamp(4, 5),
  },
  [`.${classes.rhombus}`]: {
    width: utils.clamp(4, 5),
    height: utils.clamp(4, 5),
    transform: 'rotate(45deg)',
  },
  [`.${classes.abbreviation}`]: {
    fontSize: utils.clamp(12, 20),
    fontWeight: 700,
    width: 'min-content',
    height: 'min-content',
    minWidth: '30px',
    textAlign: 'center',
    marginTop: utils.clamp(0, 5),
  },
  [`.${classes.row}`]: {
    minHeight: '3px',
    display: 'flex',
    gap: '3px',
  },
}));
